import { createAtom } from './base';
import { getSettings } from './utils';

// Account-wide schema settings, e.g. { default_upload_schema_id: 42 }.
// The default upload schema is auto-assigned to newly uploaded assets when
// the upload does not specify a data_schema_id. Uses assignment instead of
// lodash merge so setting the value to null (= unset) is preserved.
export const { currentSchemaSettingsAtom, updatedSchemaSettingsAtom, schemaSettingsAtom } = createAtom('schema', {
  updater: (currentAtom: any, updatedAtom: any, get: any, set: any, action: any) => {
    const { payload } = action;

    const state = get(updatedAtom);

    set(updatedAtom, { ...state, ...payload });
  },
});

export const getSchemaSettings = (get: any) => getSettings(get, [schemaSettingsAtom, updatedSchemaSettingsAtom]);
